import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actionCreator from "../../../action/quote_order/leadcustomer.action.js";
import LeadCustomerTable from "./LeadCustomerTable.js";
import AddLeadCustomer from "./AddLeadCustomer.js";
import SearchLeadCustomer from "./SearchLeadCustomer.js";
import ShowLeadDetails from './showLeadDetails.js';
import ConfirmationBox from '../AlertBox/ConfirmationBox.js';

class AddCustomer extends React.Component {

   constructor(props) {
  super(props);
}
showModal=()=>{
  this.setState({ showModal: true });
}

closeModal = () => {
  this.setState({showModal: false,closeModalCancel:true});
}

custom(){
   document.getElementsByClassName("modal")[0].style.transform = "scale(0)"
   document.getElementsByClassName("modal")[0].style.transition = "0.6s"
   setTimeout(() => {
      this.props.handleCommonModal('close')
   },500)
}

render() {
    this.state = {
      showModal: (this.state==null )?this.props.thankYouForSaveLater:false
    };
    var cross = true;
    for (var key in this.props.displayerrorMessage) {
      //console.log(this.props.displayerrorMessage[key]);
      if (this.props.displayerrorMessage[key] != "") {
         cross = false;
      }
   }
    //console.log(this.props.displayerrorMessage,this.props.checkLeadCustomerValidate,cross);
      return (
         <div>
            <ConfirmationBox />
            <Modal centered show={this.props.showCustomerModal && this.props.confirmationBoxShow === false} backdrop='static' keyboard={false} onHide={(e)=>this.props.handleCommonModal('close')} dialogClassName='add-customer-modal react-modal' backdropClassName="ract-modal-pre-parent" >
            
               <div className="btn-group pull-right">

                  <div className={this.props.orderLaterSubmitBtn ? "form-submiting w-100" : "w-100"}>
                  <button className="close" onClick={(e)=>this.custom(e)}><span className="icon-close"></span></button>
                     <Modal.Body>
                       
                        {(Object.keys(this.props.searchData).length<=0 && (this.props.LeadCustomerData.ShowEdit!=true))?
                          <>
                           <AddLeadCustomer/>
                           <SearchLeadCustomer/>
                          </>
                          :null
                        }
                         
                        
                         {(Object.keys(this.props.searchData).length>0 && (this.props.LeadCustomerData.ShowEdit!=true))?
                          <>
                           <SearchLeadCustomer/>
                           <LeadCustomerTable/>
                          </>
                          :null
                          }
                          
                        
                         {((this.props.LeadCustomerData!=undefined && this.props.LeadCustomerData.ShowEdit==true))?
                          <ShowLeadDetails/>:null
                        }
                     </Modal.Body>
                  </div>
               </div>
            </Modal>
            
         </div>
      )
   }
}
const mapStateToProps = (state) => {
   return state.leadcustomerReducer
}


export default connect(
   mapStateToProps,
   actionCreator
)(AddCustomer);
